<template>
    <div class="col-12" style="padding: 0!important; text-align: justify!important;">

        <div class="col-12" style="background-color: rgb(0 181 164 / 7%); padding: 0.2%; text-align: center">
            <img src="/images/privacy.png" alt="contrat-img" width="40%">
            <h3 style="font-size: 18pt!important;color: rgb(0 181 164)">Politique de confidentialité</h3>
            <p class="mt-5" style="font-size: 12pt">
                Le respect de votre vie privée est le plus important pour nous
            </p>
        </div>

        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">1. Aperçu</h3>
            </div>
            <div class="mt-4">

                <p style="font-size: medium!important;">
                    Pour réduire les risques de fraude, de blanchiment d’argent et toutes autres malversations
                    financières,
                    Intram vous demande de fournir des informations vous concernant et des informations relatives à vos
                    moyens
                    de paiements et/ou votre entreprise. En acceptant les conditions du présent Règlement sur le respect
                    de la
                    vie privée, vous acceptez que Intram traite vos données de la manière décrite dans ce règlement. Le
                    présent
                    Règlement sur le respect de la vie privée décrit les informations que nous collectons et
                    l’utilisation que nous
                    en faisons. Intram respecte
                    l’aspect confidentiel de vos informations et ne les utilisera que conformément à la loi n° 2017-20
                    précitée.
                </p>

                <p style="font-size: medium!important;">
                    Nous nous engageons à ne pas divulguer, ni vendre, ni louer vos informations personnelles à des
                    tiers à des fins
                    publicitaires sans votre consentement explicite. Toutefois, pour pouvoir améliorer continuellement
                    la qualité du service
                    Intram et protéger les intérêts de nos utilisateurs, nous devrons, dans certains cas à savoir:
                    sous-traitance ou délégation
                    pour un service, partenariat pour intégration d’un service, partager avec des tiers des informations
                    personnelles vous concernant,
                    de manière très restreinte, toujours dans le respect de ce règlement. Il est important que vous
                    lisiez attentivement le présent
                    Règlement sur le respect de la vie privée, car il s’applique à tous les services Intram.
                </p>

                <p style="font-size: medium!important;">
                    Chaque Compte Intram doit être lié à un numéro de téléphone mobile. Chaque compte Intram peut être
                    aussi lié
                    à un compte bancaire. Intram permet d’effectuer et/ou recevoir des paiements sur tous les sites
                    acceptant Intram
                    ou grâce à toutes les ressources liés aux services Intram tels que le Clic
                    and Pay (CnP), le Transfert de Compte à Compte (TCC) et les APIs.
                </p>


                <p style="font-size: medium!important;">
                    Certaines pages du site internet de Intram comportent des liens vers des sites tiers. Ces sites
                    disposent
                    de leurs propres règlements sur le respect de la vie privée et Intram décline toute responsabilité
                    concernant
                    les activités de ces tiers. Les utilisateurs qui soumettent des informations vers ces sites tiers ou
                    par leur
                    intermédiaire doivent prendre connaissance des déclarations de respect de la vie privée que ces
                    sites
                    appliquent avant de leur communiquer des informations personnelles.
                </p>


            </div>

        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">2. Informations collectées</h3>
            </div>
            <div class="mt-4">
                <h5>2.1. Informations obligatoires</h5>

                <p style="font-size: medium!important;">
                    Pour ouvrir un Compte Intram, vous devez nous communiquer des informations basiques :

                </p>
                <ul style="margin-left: 3%;font-size: medium!important;">
                    <li>Client : email, pays et un mot de passe pour votre authentification.
                    </li>
                    <li>Marchand : site web, nom de la compagnie, Acronyme, email, caégorie de marchand, pays, CNI ou
                        Passport, registre de commerce et du crédit mobilier et l'IFU .
                    </li>
                </ul>
            </div>

            <div class="mt-4">
                <h5>2.2. Accès à vos informations et leurs modifications</h5>
                <p style="font-size: medium!important;">
                    Conformément à la loi béninoise sur la protection des données à caractère personnel, vous pouvez
                    accéder à vos
                    informations personnelles que vous nous avez communiquées et les modifier ou changer des paramètres
                    relatifs à votre
                    compte Intram à tout moment en vous connectant à votre compte sur le site Intram. Vous pouvez
                    également suspendre
                    ou supprimer votre compte définitivement. Dans ce dernier cas, nous le signalons dans notre base de
                    données comme étant
                    "supprimé" mais nous conservons les informations qui lui sont associées pour une durée de dix (10)
                    ans maximum conformément
                    à la loi contre le blanchiment de capitaux et à la loi contre le financement du terrorisme. Cela est
                    nécessaire pour prévenir
                    les fraudes, afin que des personnes malveillantes ne puissent éviter d’être détectées simplement en
                    supprimant leur compte, puis
                    en ouvrant un nouveau compte. Toutefois, si vous supprimez votre compte, nous nous engageons à ne
                    pas utiliser, vendre ou
                    informations personnelles à des tiers à quelques fins que ce soit, sauf pour prévenir de la fraude
                    et permettre
                    l’application de la réglementation, ou si la loi l’exige. Vous pouvez par ailleurs exercer
                    votre droit d’opposition au traitement de vos données personnelles en envoyant un courrier à Intram
                    sur <a href="mailto:legal@intram.org">contact@intram.org</a>.
                </p>
            </div>

            <div class="mt-4">
                <h5>2.3. Informations sur la transaction</h5>
                <p style="font-size: medium!important;">
                    Lorsque vous effectuez un paiement sur un site internet utilisant Intram, nous demandons
                    des informations liées à ladite transaction. Lesdites informations incluent le montant,
                    le type de la transaction (achat de biens ou de services), d’autres détails de l’achat,
                    identifiant et l’adresse email du tiers. Ces informations sont transmises par le site
                    internet ou par l’intermédiaire de l’utilisateur en question. Nous conservons ces informations
                    pour chaque transaction que vous effectuez. Ces informations sont conservées
                    pour une durée de dix (10) ans maximum après la résiliation de votre contrat avec Intram.
                </p>

                <p style="font-size: medium!important;">
                    Nous collectons également des informations sur les sites où vous effectuez des paiements :
                    nombre de paiements, zone géographique, intérêt afin améliorer votre expérience d’utilisation
                    de nos services et pour vous faire des offres adaptées à vos habitudes.
                </p>

            </div>

            <div class="mt-4">
                <h5>2.4. Informations vous concernant provenant d’un tiers</h5>
                <p style="font-size: medium!important;">
                    Afin de protéger tous nos utilisateurs "Client" et "Marchand" contre les risques
                    de fraude potentielle et de blanchiment d’argent, nous vérifions les informations
                    fournies auprès des sites du réseau d’acceptation de Intram, auprès d’opérateurs
                    téléphones/services de m-payment, auprès des banques ou autorités de régulations et
                    autres tiers qui permettraient d’assurer la sécurité, la légalité et la transparence.
                </p>
                <p style="font-size: medium!important;">
                    Intram se réserve le droit, à son entière discrétion, de se procurer régulièrement
                    et d’étudier un rapport d’activité et/ou de solvabilité
                    sur l’utilisateur fourni par un organisme bancaire ou service de mobile money.
                </p>
                <p style="font-size: medium!important;">
                    Si vous utilisez votre Compte Intram pour vendre des biens, nous pouvons
                    également collecter des informations publiques sur votre société et votre
                    comportement sur les plateformes de médias sociaux (telles que l’adresse
                    email et le nombre de mentions "j’aime" et "abonnés"), dans la mesure
                    nécessaire pour confirmer une évaluation
                    de vos transactions et/ou de votre société, y compris sa taille et
                    la taille de sa base de clientèle.
                </p>

            </div>
            <div class="mt-4">
                <h5>2.5. Vérifications supplémentaires</h5>
                <p style="font-size: medium!important;">
                    Si nous ne pouvons pas vérifier les informations que vous nous communiquez,
                    nous pouvons vous demander de nous fournir des informations supplémentaires
                    par téléchargement ou par fax (soit votre permis de conduire, soit un relevé
                    de carte bancaire et/ou une facture récente de service public ou soit toute
                    autre information permettant de vous associer aux informations communiquées), ou
                    de répondre à des questions complémentaires en ligne qui nous permettront de
                    vérifier vos informations.
                </p>
            </div>
            <div class="mt-4">
                <h5>2.6. Cookies, balises web et autres technologies similaires</h5>
                <p style="font-size: medium!important;">
                    Lorsque vous visitez ou interagissez avec nos sites, services, applications, outils,
                    publicités et messageries, nous ou nos prestataires de services autorisés pouvons
                    utiliser des cookies, balises web et autres technologies similaires pour stocker
                    des informations qui nous permettront de vous fournir une meilleure expérience,
                    plus rapide et plus sécurisée.
                </p>
                <p style="font-size: medium!important;">
                    Nous proposons certains services, applications et outils disponibles uniquement
                    par le biais desdites technologies. Vous êtes toujours libre de bloquer, supprimer
                    ou désactiver lesdites technologies si votre navigateur ou appareil le permet.
                    Cependant, si vous refusez les cookies ou autres technologies similaires,
                    il se peut que vous ne puissiez pas utiliser certains services, applications
                    ou outils. Il se peut
                    que vous deviez également saisir votre mot de passe plus
                    fréquemment lors d’une session.
                </p>
                <p style="font-size: medium!important;">
                    Nous protégeons nos cookies et autres technologies similaires afin que seuls
                    nous et/ou nos prestataires de services autorisés puissions les interpréter
                    en leur attribuant un identifiant unique, conçu pour empêcher leur interprétation
                    par des tiers non autorisés. Vous êtes susceptible de rencontrer des cookies,
                    balises web ou autres technologies similaires provenant de tiers autorisés,
                    communément appelés prestataires de services, auxquels nous avons recours pour
                    nous aider avec divers aspects du fonctionnement de nos sites, ou pour vous
                    fournir nos services, applications et outils.

                </p>

            </div>
            <div class="mt-4">
                <h5>2.7. Sondages et questionnaires</h5>
                <p style="font-size: medium!important;">
                    De temps à autre, nous proposons des sondages et questionnaires facultatifs
                    à nos utilisateurs afin de réunir des informations démographiques ou d’évaluer
                    leurs centres d’intérêt et leurs besoins pour améliorer nos services. L’usage
                    des informations collectées est expliqué en détail dans le sondage lui-même.
                    Si, dans ces questionnaires et ces sondages, nous demandons des informations
                    personnelles à nos utilisateurs, ces derniers sont informés de l’utilisation
                    qui en sera faite avant même de prendre part au sondage ou de répondre au
                    questionnaire. Le refus de participation au sondage ou questionnaire est sans conséquence.
                </p>

            </div>


        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">3. Règlement de divulgation
                    d’informations</h3>
            </div>

            <div class="mt-4">
                <h5>3.1. Divulgation d’informations à des tiers</h5>
                <p style="font-size: medium!important;">
                    Intram vendra, louera ou divulguera vos informations personnelles à des tiers
                    que dans des cas précis et aux fins décrites dans le présent règlement sous
                    réserve de votre consentement et dans le respect des dispositions de la
                    loi  2017-20 sur les données personnelles.
                    Plus particulièrement, vous acceptez et donnez pour instruction à Intram de :
                </p>
                <ul style="margin-left: 3%; font-size: medium">
                    <li>Divulguer des informations, y compris et sans limitation, des informations relatives
                        à la transaction ou au compte, des coordonnées personnelles et les contenus de
                        communications à la police, aux forces de l’ordre, aux entités gouvernementales,
                        intergouvernementales ou supranationales compétentes, services ou autorités ou
                        organisations de régulation ou d’autorégulation compétents ou à tout tiers, avec
                        lequel nous pensons devoir coopérer dans le cadre d’enquêtes relatives à des
                        fraudes ou à d’autres types d’activités illégales ou potentiellement illégales
                        ou pour mener des enquêtes relatives à des violations de nos Conditions d’utilisation
                        (y compris, sans limitation, votre fournisseur de service de mobile money).
                        Si des informations fausses ou erronées nous sont fournies et que la fraude est avérée,
                        nous communiquerons tous les détails nécessaires aux organismes de prévention des fraudes.
                        Par conséquent, les autorités publiques pourront avoir accès à ces informations et les utiliser.
                        Nous, ainsi que d’autres organisations, pouvons également accéder et utiliser (y compris depuis
                        d’autres pays) auxdites informations et aux informations enregistrées par les organismes de
                        prévention des fraudes en vue d’éviter la fraude et le blanchiment d’argent;
                    </li>
                </ul>
                <p style="font-size: medium!important;">
                    Sous réserve de votre consentement, vous autorisez Intram:
                </p>
                <ul style="margin-left: 3%; font-size: medium">
                    <li>Si, en tant que marchand, vous avez recours à un tiers pour intégrer ou accéder à Intram, de
                        divulguer au dit partenaire le statut de votre intégration Intram, le fait de savoir si vous
                        avez un compte Intram actif et si vous travaillez déjà avec un autre partenaire d’intégration
                        Intram;
                    </li>
                    <li>Divulguer des données statistiques agrégées avec nos partenaires commerciaux ou pour des
                        relations publiques. Cependant, ces données d’ensemble ne sont pas liées à des informations
                        personnelles;
                    </li>
                    <li>Comme toute autre société, Intram peut être amenée à fusionner avec une autre société ou être
                        rachetée. En cas d’acquisition ou de fusion, vous acceptez que le successeur ait accès aux
                        informations détenues par Intram, y compris les informations sur les comptes des utilisateurs,
                        mais il est toujours lié par la loi n° 2017-20 sur la protection des données à caractère
                        personnel, le présent Règlement sur le respect de la vie privée, sauf modification particulière;
                    </li>
                    <li>Vérifier vos informations fournies chez un opérateur télécoms ou fournisseur de service de
                        mobile money ou banque ou tout organisme financier compétent afin de confirmer les informations
                        que vous nous aurez fournies;
                    </li>
                    <li>Divulguer des informations basiques à des fins publicitaires dans le respect de la délibération
                        n°2014-20/CDP du 31 mai 2014 sur les conditions de la prospection directe, notamment. Ces
                        informations basiques sont : sexe, âge, pays ou ville de résidence ou d’origine, profession.
                    </li>
                </ul>

            </div>
            <div class="mt-4">
                <h5>3.2. Divulgation d’informations aux utilisateurs Intram</h5>
                <p style="font-size: medium!important;">
                    Nous communiquons régulièrement par email avec nos utilisateurs afin de leur fournir les services
                    demandés. Nous communiquons également par téléphone pour :
                </p>

                <ul style="margin-left: 3%; font-size: medium">
                    <li> résoudre les réclamations clients ou des réclamations déposées par des utilisateurs;</li>
                    <li> répondre aux demandes adressées au service clientèle;</li>
                    <li>informer nos utilisateurs d’une éventuelle utilisation frauduleuse de leur Compte ou de
                        transactions supposées illégitimes;
                    </li>
                    <li> confirmer des informations liées à l’identité, la société ou l’activité du compte d’un
                        utilisateur;
                    </li>
                    <li> effectuer des sondages auprès des clients;</li>
                    <li>étudier des transactions suspectes.</li>
                </ul>
            </div>
            <div class="mt-4">
                <h5>3.3. Divulgation d’informations aux comptes Marchand</h5>
                <p style="font-size: medium!important;">
                    Pour faciliter les transactions entre les utilisateurs de Intram, notre service accorde un accès
                    restreint aux coordonnées ou aux informations de livraison des autres utilisateurs aux Comptes
                    Business. En tant que vendeur, vous pouvez accéder à l’identifiant de l’acheteur, à son adresse
                    email et à d’autres coordonnées ou informations de livraison relatives à l’acheteur, et en tant
                    qu’acheteur vous pouvez avoir accès à l’identifiant du vendeur, à son adresse email et à d’autres
                    coordonnées du vendeur.
                </p>
                <p style="font-size: medium!important;">
                    Vous acceptez, s’agissant des informations personnelles d’autres utilisateurs susceptibles de vous
                    parvenir par le biais de Intram, d’une communication Intram ou d’une transaction effectuée via
                    Intram, d’utiliser ces informations uniquement dans le cadre :

                </p>

                <ul style="margin-left: 3%; font-size: medium">
                    <li> de communications relatives à Intram à l’exclusion de messages commerciaux non sollicités,</li>
                    <li> d’actions auxiliaires relatives aux paiements Intram ou aux transactions pour lesquelles Intram a été utilisé (Ex :livraison, réclamations relatives à la livraison...)</li>
                    <li>de toute autre finalité à laquelle l’utilisateur aura consenti après qu’il en a pris connaissance.
                    </li>
                </ul>
                <p style="font-size: medium!important;">
                    Dans tous les cas, le vendeur doit permettre aux utilisateurs de supprimer de sa base de données les enregistrements les concernant et de réviser les informations qu’il a collectées à leur sujet.
                </p>
            </div>


        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">4. Sécurité de vos informations</h3>
            </div>
            <div class="mt-4">
                <h5>4.1. Durée du Contrat et procédure de fermeture, suspension et restriction du Compte</h5>

                <p style="font-size: medium!important;">
                    En application de la loi n° 2017-20 du 20 avril 2018 sur la protectin des donénes personnelles, Intram s’engage à traiter vos informations personnelles selon les normes les plus strictes en matière de sécurité et de confidentialité de l’information. Nous utilisons des systèmes de sécurité informatiques tels que des pare-feux, le cryptage de données les technologies les plus récentes et fréquemment mis à jour. Nous contrôlons l’accès à nos bâtiments et à nos fichiers, et nous autorisons l’accès aux informations personnelles uniquement aux employés qui en ont besoin pour l’accomplissement de leur mission.
                </p>
                <p style="font-size: medium!important;">
                    La sécurité de votre compte Intram dépend aussi de la manière dont vous protégez votre mot de passe. Vous ne devez communiquer votre mot de passe à personne. Les représentants de Intram ne vous demanderont jamais votre mot de passe que ce soit par téléphone et encore moins par email. Par conséquent, tout email ou tout autre type de correspondance vous demandant votre mot de passe ou informations personnelles doit être considéré comme suspect et non autorisé et être signalé à Intram. Si vous communiquez votre mot de passe Intram à un tiers pour un motif quelconque, ce tiers aura accès à votre compte et à vos informations personnelles et vous serez tenu pour responsable des opérations effectuées avec votre mot de passe. Si vous pensez que quelqu’un a pu accéder à votre mot de passe, modifiez-le immédiatement en vous connectant à votre compte, puis contactez-nous immédiatement.
                </p>

            </div>

        </div>
        <div class="col-md-10 col-lg-10 col-12 offset-lg-1 offset-md-1 card mt-8 p-5 border-top-card mb-4">
            <div class="text-center">
                <h3 style="font-size: 19pt!important;color: rgb(0 181 164)">5. Responsabilité de Intram</h3>
            </div>
            <div class="mt-4">

                <p style="font-size: medium!important;">
                    Intram garanti que ses procédures quotidiennes respectent la loi béninoise 2017-20 du 20 avril 2018 portant Code du numérique en République du Bénin et s’engage sur le respect de ce Règlement de la vie privée. Si vous avez des questions concernant le présent Règlement sur le respect de la vie privée, les pratiques de Intram en matière de traitement des informations ou quelque activité de Intram, vous pouvez nous contacter ou composer le numéro de service clientèle indiqué sur notre site.
                </p>

            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "conditionsUtilisateur",
        methods: {
            checkisDashboard() {
                this.$emit('checkisDashboard', false);
            },
        }
    }
</script>

<style scoped>
    .elementPay {
        color: #00B7A4;
        font-weight: bold;
    }

    .border-top-card {
        border-top: #00B7A4 solid 5px;
    }


</style>